// import React from 'react';
// import { Button } from 'primereact/button';  

import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import Footer from "../components/Footer";
import Header from "../components/Header";
import { useNavigate } from "react-router-dom";
import webLogin from "../types/webLogin";
import { useContext, useState } from "react";
import { LoginContext } from "../context/LoginContext";
import DataAPI from "../api/DataApi";
import { Message } from "primereact/message";

function Login() {
    const navigate = useNavigate();
    // const { setWebLoginContextValue } = useContext(Logi  nContext);
    const [ userStr, setUserStr ] = useState('');
    const [ passwordStr, setPasswordStr ] = useState('');
    const [ loading, setloading ] = useState(false);
    const [ error, setError ] = useState(false);
    const defaultLoginContext = useContext(LoginContext);
      
    return (
        <div className="App flex flex-col min-h-[100vh] justify-center" >
            <Header />
            <div className="w-full flex flex-row justify-center"  style={{ flex: '1 1 auto' }}>
                <div className="maincontainer md:my-8">
                    <div className="flex flex-row mt-8">
                        <div className="hidden md:block md:w-1/12 text-center md:p-10 text-lg"></div>
                        <div className="w-full md:w-2/5 text-center p-4 md:p-10 text-lg space-y-4 ">
                            <div className="text-standardGray text-3xl font-bold font-Roboto">Iniciar Sesion</div>
                            <div className="flex flex-col text-left mt-4">
                                <div className="font-bold text-standardGray">Usuario</div>
                                <div><InputText onKeyUp={keyUpFunction} value={userStr} onChange={e => setUserStr(e.target.value)} className="w-full" /></div>
                            </div>
                            <div className="flex flex-col text-left mt-4">
                                <div className="font-bold text-standardGray">Contrase&ntilde;a</div>
                                <div><InputText onKeyUp={keyUpFunction} value={passwordStr} onChange={e => setPasswordStr(e.target.value)} className="w-full" type="password" /></div>
                            </div>
                            <div className="md:mt-4">
                                <div className="flex flex-col">
                                {error && <Message severity="error" text="Datos Incorrectos" /> }
                                <div className="mt-2">
                                    <Button disabled={loading} onClick={()=> {setLogin()}} className="web-boton"> { loading ? 'Cargando...' : 'Continuar' } </Button>
                                </div>
                                </div>
                            </div>
                        </div>
                        <div className="hidden md:block md:w-2/5 justify-center text-center ">
                            <img className="h-auto w-full" src="./assets/img/login6.webp" alt="login img" />
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );

    function keyUpFunction(event: any) {
        if (event.key === "Enter") {
            setLogin();
        }
    }

    function setLogin() {

        setloading(true);

        DataAPI.getLogin(userStr, passwordStr).then((data) => {
            setloading(false);
            let error = false;
            
            if ( data.resultado === 1 ) {
                if ( data.objeto.RET === 1 ) {
                    let newLogin: webLogin = new webLogin();
                    newLogin.isLogin = true;
                    newLogin.token = data.objeto.VALOR;
                    
                    newLogin.administrator = data.objeto.ADMINISTRADOR;
                    newLogin.lastCheck = new Date();
                    
                    let minutes: Date = new Date();
                    minutes.setMinutes(newLogin.lastCheck.getMinutes() + 10);
                    newLogin.validationDate = minutes;
                    newLogin.loaded = true;

                    DataAPI.getCompanyData(newLogin.token).then((dataSrv)=> {
                        if ( dataSrv.resultado === 1 ) {
                            localStorage.setItem('company', JSON.stringify(dataSrv.objeto));
                            newLogin.companyName = dataSrv.objeto.name;
                            newLogin.userName = dataSrv.objeto.username;
                        }
                        setloading(false);
                    });
                
                    defaultLoginContext?.setWebLoginContextValue(newLogin);
                    localStorage.setItem('token', newLogin.token);

                    if ( !newLogin.administrator ) {
                        navigate('/resumen');
                    } else {
                        navigate('/clientes');
                    }
                    
                } else {
                    error = true;
                }
            } else {
                error = true;
            }

            if ( error ) {
                setError(error);
                setTimeout(() => {
                    setError(false);
                }, 2000);
            }
        }).catch((error) => {
            console.log(error);
        });

        
    }
}


  
  export default Login;
